
;(function($, window, document) {
  


  const videos = $('.video-header, .bg-video');

  if (videos.length > 0) {

    $.each(videos, function() {
      
      const video_el = $(this);
      const iframe = $(this).find('iframe')[0];
      

      if (!iframe) {
        return;
      }
      // @ts-ignore
      const player = new Vimeo.Player(iframe);

      // Controls
      const play_controls = $(this).find('.play-button')[0];
      const volume_controls = $(this).find('.mute-button')[0];
      const transcript_controls = $(this).find('.transcript-toggle')[0];
      const track_controls = $(this).find('.track-toggle')[0];

      player.on('loaded', () => {
        iframe.parentElement.querySelector('.video-thumbnail').style.display = 'none';
      });

      // Reset on ended
      player.on('ended', () => {
        player.setCurrentTime(0).then(() => {
          player.pause();
          video_el.removeClass('playing');
        }).catch((error: any) => {
          console.error(error);
        });
      })

      // Play button actions
      if (play_controls) {

        play_controls.addEventListener('click', () => {
          player.getPaused().then(function(paused) {
            if (paused) {
              video_el.addClass('playing');
              player.play();
            } else {
              video_el.removeClass('playing');
              player.pause();
            }
          });
        });
      }


      // Mute button actions
      if (volume_controls) {

        volume_controls.addEventListener('click', () => {
          player.getMuted().then(function(muted) {
            if (!muted) {
              video_el.addClass('muted');
              player.setMuted(true);
            } else {
              video_el.removeClass('muted');
              player.setMuted(false);
            }
          });
        });
      }

      // Mute button actions
      if (transcript_controls) {

        transcript_controls.addEventListener('click', () => {

          const isTranscriptOpen = video_el.hasClass('transcript-open');

          if (!isTranscriptOpen) {
            video_el.addClass('transcript-open');
            transcript_controls.setAttribute('aria-expanded', 'true');

            const yOffset = 100;

            window.scrollTo({ top: yOffset, behavior: 'smooth' });

          } else {
            video_el.removeClass('transcript-open');
            transcript_controls.setAttribute('aria-expanded', 'false');
          }
          
        });
      }

      player.getAudioTracks()
      .then((tracks) => {
        // console.log('Available audio tracks:', tracks);

        const track_select = video_el.find('.track-select')[0];

        tracks.forEach((track: any, index: number) => {
          const track_button = document.createElement('button');
          track_button.className = 'track-option';
          track_button.setAttribute('data-track-lang', track.language);
          track_button.setAttribute('data-track-kind', track.kind);
          track_button.textContent = track.label ? `${track.label}` : track.language.toUpperCase();

          track_button.addEventListener('click', () => {

            
            const lang = track_button.getAttribute('data-track-lang');
            const kind = track_button.getAttribute('data-track-kind');

            close_track_menu();
            player.selectAudioTrack(lang, kind).then(() => {
              // console.log(`Switched to audio track ${index}`);
            }).catch((error: any) => {
              // console.error('Error switching audio track:', error);
            });
          });

          track_select.appendChild(track_button);
        });

        // Show track controls
        video_el.find('.track-wrapper')[0].style.display = 'flex';

        // tracks is an array of track objects
      })
      .catch((error) => {
        // console.error('Error getting audio tracks:', error);
      });

      function toggle_track_menu() {  
        const isTrackOpen = video_el.hasClass('track-open');

        if (!isTrackOpen) {
          video_el.addClass('track-open');
          track_controls.setAttribute('aria-expanded', 'true');
        } else {
          video_el.removeClass('track-open');
          track_controls.setAttribute('aria-expanded', 'false');
        }
      }

      function close_track_menu() {
        const isTrackOpen = video_el.hasClass('track-open');

        if (isTrackOpen) {
          video_el.removeClass('track-open');
          track_controls.setAttribute('aria-expanded', 'false');
        }
      }
      
      // Close track menu on outside click
      document.addEventListener('click', (event) => {

        const track_wrapper = video_el.find('.track-wrapper')[0];
        if (!track_wrapper) { return; }

        const isClickInside = track_wrapper.contains(event.target as Node); 
        if (!isClickInside) {
          close_track_menu();
        }
      });

      track_controls.addEventListener('click', () => {
        toggle_track_menu();
      });

    });

  }

  const standard_videos = $('.video-default');
  
  
  if (standard_videos.length > 0) {

    $.each(standard_videos, function() {
      
      const video_el = $(this);
      
      const transcript_controls = $(this).find('.transcript-toggle')[0];

      // Mute button actions
      if (transcript_controls) {

        transcript_controls.addEventListener('click', () => {

          const isTranscriptOpen = video_el.hasClass('transcript-open');

          if (!isTranscriptOpen) {
            video_el.addClass('transcript-open');
            transcript_controls.setAttribute('aria-expanded', 'true');
          } else {
            video_el.removeClass('transcript-open');
            transcript_controls.setAttribute('aria-expanded', 'false');
          }

        });
      }
    }); 
  }


  function pause_videos() {
    
    $.each(videos, function() {

      const iframe = $(this).find('iframe')[0];

      // @ts-ignore
      const player = new Vimeo.Player(iframe);
      
      $(this).removeClass('playing');
      player.ready().then( () => {
        player.pause();
      });
    });
    
    $.each(standard_videos, function() {


      const iframe = $(this).find('iframe')[0];

      // Vimeo
      if (iframe.src.includes('vimeo.com')) {

        // @ts-ignore
        const player = new Vimeo.Player(iframe);
        player.pause();

      // Youtube
      } else if (iframe.src.includes('youtube.com') || iframe.src.includes('youtu.be') || iframe.src.includes('youtube-nocookie.com')) {

        iframe.contentWindow?.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
      } else {
        return;
      }

    });
  }


  document.addEventListener('tms:reduce-motion-change', pause_videos);


// @ts-ignore
})(jQuery, window, document);

function onYouTubeIframeAPIReady() {

}